<template>
  <v-card flat>
    <v-card-text>
      Deine Daten wurden erfolgreich an uns übermittelt. Wir halten dich über den aktuellen Bearbeitungsstatus auf dem
      Laufenden.
    </v-card-text>
    <div v-if="askForFeedback">
      <thg-rating-form
        :title="$t('report.thgRating.title')"
        :description="$t('report.thgRating.description')"
        ratingKey="quickcheckout"
      ></thg-rating-form>
      <v-divider class="my-4"></v-divider>
    </div>
    <v-card-actions>
      <v-btn block @click="close" color="info" dark> Zur Fahrzeugübersicht </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { RatingMeModule } from "@/store/modules/rating-me.store";
import { Component, Vue } from "vue-property-decorator";
import ThgRatingForm from "../rating/ThgRatingForm.vue";

@Component({
  components: { ThgRatingForm }
})
export default class ThgSuccessCard extends Vue {
  get askForFeedback() {
    return RatingMeModule.askForFeedback;
  }
  close() {
    this.$emit("close");
  }
}
</script>

<style></style>
